<template>
<div class="work" id="work-8">
	<h2><span>05</span>SCOO</h2>
	<div class="subtitle">
		<h3><span>Year</span>2019</h3>
		<h3><span>Product</span>App and Website</h3>
		<h3><span>Technology</span>Phonegap / Wordpress / Gsap</h3>
	</div>
	<blockquote>
		SCOO is a Startup from Brazil for rent micro mobility vehicles through an App, has a large investiment from a state company (CCR) and noted ventures of Brazil.
	</blockquote>
	<figure class="int">
		<figcaption>
			<h3>Objective for this project</h3>
			<p>To provide the best improvements comparing to competitors that came out of country, to give value and create a look alike as an inovative service and cheap price at same time.</p>
			<h3>My Role</h3>
			<p>All website visual guideline, layouts and front-end development, for the app i´ve done the concept, ux flow and prototype, working from the inital draw to the js interactions.</p>
		</figcaption>
		<span><img src="../../assets/scoo_01.jpg" alt="Scoo site"></span>
		<span><img src="../../assets/scoo_02.jpg" alt="Scoo app"></span>
	</figure>
	<figure class="half">
		<figcaption>
			<h3>The Solution</h3>
			<p>The entire project was exhaustively planned to grab the attention of subway public, the average middle-classes customers and the investors.</p>
			<p>From their first impressions of website, released at first, to the final app launch all the solution was based on the subway crowd behavior, the day and night trafic and conditions.</p>
		</figcaption>
		<img src="../../assets/scoo_01.png" alt="scoo mobile app">
		<img src="../../assets/scoo_02.png" alt="scoo mobile site">
	</figure>
	<figure class="half">
		<figcaption>
			<blockquote>We´ve took a project with a tight budget and a large demand, even with some failures we achive on time a entire app, site and client satisfaction.</blockquote> 
		</figcaption>
		
	</figure>
	<figure>
		<span><img src="../../assets/scoo_03.jpg" alt="SCOO"></span>
	</figure>
	<blockquote>
		"The feel of doing something that promisses goes big, "flooding in the mainstream", with so inovative service and technology made a great learning opportunity, the result can be accessed in <a href="//scoo.mobi" target="_blank">scoo.mobi</a>"
	</blockquote>
</div>
</template>